import React, { useEffect, useState } from 'react';
import { Registration } from './funnel/Registration';
import { Qualify } from './funnel/Qualify';
import { ThankYou, Confirmed } from './funnel/ThankYou';
import { initPixel, track } from './funnel/pixel';
import { protect } from './utils/protect';
import { applySeo } from './utils/seo';

// Ruteo por hash:
// #/            Paso 1: registro (nombre, email, WhatsApp)
// #/aplicar     Paso 2: preguntas de filtro, una por pantalla
// #/agenda      Video explicativo + calendario GHL
// #/confirmada  Redirección post-reserva desde GHL
function getRoute() {
  return window.location.hash.replace(/^#/, '') || '/';
}
export function App() {
  const [route, setRoute] = useState(getRoute());
  useEffect(() => {
    initPixel();
    track('PageView');
    const h = () => {
      setRoute(getRoute());
      window.scrollTo(0, 0);
      track('PageView');
    };
    window.addEventListener('hashchange', h);
    return () => window.removeEventListener('hashchange', h);
  }, []);

  // Capa anti-copia (una sola vez)
  useEffect(() => protect(), []);

  // SEO: título, robots y canonical en cada cambio de ruta
  useEffect(() => {
    applySeo(route);
  }, [route]);
  const go = (r: string) => {
    window.location.hash = r;
  };
  return <div className="min-h-full w-full bg-white" data-id="element-0" data-mp="3rcsuzli5vya7">
      {route === '/aplicar' ? <Qualify onDone={() => go('/agenda')} data-id="element-1" data-mp="4wxfu7a14id" /> : route === '/agenda' ? <ThankYou data-id="element-2" data-mp="2zld1r8m3ndb0" /> : route === '/confirmada' ? <Confirmed data-id="element-3" data-mp="2zmo5j8fjol24" /> : <Registration onSuccess={() => go('/aplicar')} data-id="element-4" data-mp="2zng1ikd20ksx" />}
    </div>;
}